import { render, staticRenderFns } from "./parent-weeklyplan.vue?vue&type=template&id=4eb24bfa&"
import script from "./parent-weeklyplan.vue?vue&type=script&lang=js&"
export * from "./parent-weeklyplan.vue?vue&type=script&lang=js&"
import style0 from "./parent-weeklyplan.vue?vue&type=style&index=0&id=4eb24bfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports